module.exports = __webpack_public_path__ + "imgs/Leafwell.6a2c48e8c7e10a4f3ebcabceff74f59f.png";